import React from 'react';
import PropTypes from 'prop-types';
import { Controller, useFormContext } from 'react-hook-form';

import SelectPartner from 'components/partners/SelectPartner';

export default function FormSelectPartner(props) {
  const {
    control,
    setValue,
    getValues,
    clearErrors,
    formState: { errors },
  } = useFormContext();

  const { id, name, label, required, size, fullWidth, disabled, variant } = props;

  return (
    <Controller
      name={name}
      control={control}
      render={() => {
        return (
          <SelectPartner
            id={id}
            name={name}
            label={label}
            error={!!errors[name]}
            helperText={errors[name]?.message ?? ''}
            required={required}
            size={size}
            fullWidth={fullWidth}
            disabled={disabled}
            variant={variant}
            onSelected={(value) => {
              setValue(name, value);
              clearErrors(name);
            }}
            value={getValues(name)}
          />
        );
      }}
    />
  );
}

FormSelectPartner.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
  label: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  size: PropTypes.oneOf(['medium', 'small', 'large']),
  fullWidth: PropTypes.bool.isRequired,
  multiline: PropTypes.bool,
  variant: PropTypes.oneOf(['outlined', 'standard', 'filled']),
  value: PropTypes.string,
};

FormSelectPartner.defaultProps = {
  id: 'select-partner',
  label: 'Select a country',
  required: false,
  disabled: false,
  fullWidth: true,
  multiline: false,
  size: 'small',
  variant: 'outlined',
};
